export function random (min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min)
}

/**
 * Randomize array element order in-place.
 * Using Durstenfeld shuffle algorithm.
 */
export const shuffleArray = (array) => {
  for (let i = array.length - 1; i > 0; i--) {
    let j = Math.floor(Math.random() * (i + 1))
    let temp = array[i]
    array[i] = array[j]
    array[j] = temp
  }
  return array
}

export function blockUi() {
  $("body").css("pointer-events", "none");
  $(".div-loading").css("display", "block");
}

export function unblockUi() {
  // setTimeout(() => {
    $(".div-loading").css("display", "none");
    window.Ladda.stopAll();
    $("body").css("pointer-events", "auto");
  // }, 1000);
}